(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Loading line: starts the moment a shopper clicks through to another page.
  const loadbar = document.createElement('div');
  loadbar.className = 'amos-loadbar';
  loadbar.setAttribute('aria-hidden', 'true');
  document.body.append(loadbar);
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.target && link.target !== '_self') return;
    if (link.hasAttribute('download')) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin) return;
    if (url.pathname === window.location.pathname && url.search === window.location.search) return;
    document.documentElement.classList.add('amos-leaving');
  });
  window.addEventListener('pageshow', () => document.documentElement.classList.remove('amos-leaving'));

  // Manifesto: split the statement into words that light up with scroll progress.
  const statements = document.querySelectorAll("[id$='__manifesto'] .rich-text__heading");
  if (!reduceMotion && statements.length) {
    statements.forEach((heading) => {
      const text = heading.textContent.trim();
      heading.setAttribute('aria-label', text);
      heading.textContent = '';
      text.split(/\s+/).forEach((word, i) => {
        if (i) heading.append(' ');
        const span = document.createElement('span');
        span.className = 'amos-word';
        span.setAttribute('aria-hidden', 'true');
        span.textContent = word;
        heading.append(span);
      });
    });

    let ticking = false;
    const update = () => {
      ticking = false;
      statements.forEach((heading) => {
        const top = heading.getBoundingClientRect().top;
        const progress = Math.min(1, Math.max(0, (window.innerHeight * 0.85 - top) / (window.innerHeight * 0.45)));
        const words = heading.querySelectorAll('.amos-word');
        const lit = Math.round(progress * words.length);
        words.forEach((word, i) => word.classList.toggle('is-lit', i < lit));
      });
    };
    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }

  // Product page: mobile buy bar that mirrors the real Add to cart button.
  const submit = document.querySelector('product-form form[action*="/cart/add"] [type="submit"]');
  if (!submit) return;

  const title = document.querySelector('.product__title h1, .product__title');
  const priceSource = document.querySelector('.product__info-container .price');

  const bar = document.createElement('div');
  bar.className = 'amos-buybar';
  bar.setAttribute('aria-hidden', 'true');

  const info = document.createElement('div');
  info.className = 'amos-buybar__info';
  const barTitle = document.createElement('p');
  barTitle.className = 'amos-buybar__title';
  barTitle.textContent = title ? title.textContent.trim() : '';
  const barPrice = document.createElement('p');
  barPrice.className = 'amos-buybar__price';
  info.append(barTitle, barPrice);

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'button';
  button.tabIndex = -1;
  button.addEventListener('click', () => submit.click());

  bar.append(info, button);
  document.body.append(bar);

  const sync = () => {
    button.textContent = submit.textContent.trim();
    button.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
    const current = priceSource && priceSource.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular');
    barPrice.textContent = current ? current.textContent.trim() : '';
  };
  sync();
  new MutationObserver(sync).observe(submit, { attributes: true, childList: true, subtree: true, characterData: true });
  if (priceSource) new MutationObserver(sync).observe(priceSource, { childList: true, subtree: true, characterData: true });

  new IntersectionObserver(([entry]) => {
    const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    bar.classList.toggle('is-visible', passed);
    bar.setAttribute('aria-hidden', String(!passed));
    button.tabIndex = passed ? 0 : -1;
  }).observe(submit);
})();
